import config from '@dragonfruit/config';
const { SNAPASK_SITE_ENDPOINT } = config;

export const LINE_PAY_CONFIRM_WEBHOOk =
  SNAPASK_SITE_ENDPOINT + '/confirm-line-pay';



// WEBPACK FOOTER //
// ./app/constants/purchase.js